/** Launch Proof disclaimers — evidence summary only, not certification. */
export const LAUNCH_PROOF_DISCLAIMERS = [
    "Launch proof summarizes evidence at a point in time — it is not a certificate of compliance, legal approval, or outcome guarantee.",
    "Surface quality checks use heuristics when evaluated server-side; they do not replace human review.",
    "Claim evidence review in Phase 1 does not validate full BusinessGraph claim bodies.",
    "Absence of an evaluated check means not evaluated — not a pass.",
];
//# sourceMappingURL=launch-proof-disclaimers.js.map